import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { ExportFormatComponent } from './export-format.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        DirectivesModule,
    ],
    exports: [ExportFormatComponent],
    declarations: [ExportFormatComponent],
})
export class ExportFormatModule {}
